module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "untitled-1"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override12"
  }, [_c('br', {
    staticClass: "calibre1"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapter-sub"
  }, [_vm._v("Acknowledgments:")]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_c('span', {
    staticClass: "no-style-override8"
  }, [_vm._v("Special gratitude is extended to Jennifer Guyor Jowett and Lori Kronser, editors extraordinaire, for their detailed critique of the early manuscript; to Rowena Carenen of WildBlue Press, for her detail-oriented and meticulous eye; to Christian Maheux, for his cover design; Linda Lou, for finding the cruise of the century; Stu and Donna, for pulling the Mediterranean trip together so nicely; and to a variety of friends and relatives – from Bill Kohlmeyer and Doc Strand and Michael J. Parker to my cousins Vinny and Bob to – hey, you know who you are – who once again served up their names and expertise to the cause. Simply put, I couldn’t get there without you. Nor would I want to.   ")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "calibre_pb_8"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11106f81","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Acknowledgments.vue
// module id = 69
// module chunks = 0